import * as React from "react";

import { Apps28Filled, Apps28Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const CorpIdentityApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "CorpIdentityApp" */ "./CorpIdentityApp");
    return { default: namedExport.CorpIdentityApp };
});

export const CorpIdentity: TeamAppConfig = {
    title: "Corp Identity Governance",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "CorpIdentity governance app provides a compliance solution for managing access permission of M365 telemetry data resources in MSFT tenant.",
    team: "DMOJ",
    publicId: "Exchange\\DMOJ",
    owner: "dmojv_cn@microsoft.com",
    role: "*",
    tags: [],
    app: CorpIdentityApp,
    path: "/CorpIdentity"
};
